<template>
  <div class="home">
    <img alt="Vue logo" src="../assets/logo.png" />
    <HelloWorld msg="Welcome to Your Vue.js App" />
    <Tile msg="Tile" />
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from "@/components/HelloWorld.vue";
import Tile from "@/components/Tile.vue";

export default {
  name: "Home",
  components: {
    HelloWorld,
    Tile,
  },
};
</script>
